<script>import { attrValue } from "../../utils/html";
export let vAlign = "start";
export let bodyAlign = null;
export let classNames = null;
const { start, end } = $$slots;
classNames = attrValue([
  "flex",
  vAlign === "center" ? "items-center" : "",
  vAlign === "start" ? "items-start" : "",
  vAlign === "end" ? "items-end" : "",
  classNames ? classNames : ""
]);
</script>

{#if !start && !end}
	<slot />
{:else}
	<div class={classNames}>
		<slot name="start" />
		<div
			class="flex-1"
			class:self-center={bodyAlign === 'center'}
			class:self-start={bodyAlign === 'start'}
			class:self-end={bodyAlign === 'end'}
		>
			<slot />
		</div>
		<slot name="end" />
	</div>
{/if}
